import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useParams} from 'react-router-dom';
import {baseUrl, formatDateTime, userLocation} from '../Univ.js'
function IpBillSummary(props) {
    const {ip_id} = useParams();
    const [inputValue, setInputValue] = useState('');
    const [ipData, setIpData] = useState([]);
    const [labData, setLabData] = useState([]);
    const [invData, setInvData] = useState([]);
    const [drugData, setDrugData] = useState([]);
    const [minviewData, setMinviewData] = useState([]);
    const [totData, setTotData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [advData, setAdvData] = useState([]);
    const [insurData, setInsurData] = useState([]);
    const [iprefundData, setIprefundData] = useState([]);
    const [hospData, setHospData] = useState([]);
    const currentDate = new Date().toISOString().slice(0, 10);
    const [viewPharmData, setViewPharmData] = useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchHosData();
    }, []);
    async function fetchHosData() {
        try {
            const response = await axios.get(baseUrl + "view-hospital/" + userLocation + "/");
            setHospData(response.data);
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        fetchTotData();
    }, []);
    function fetchTotData() {
        axios.get(`${baseUrl}view-ip-tot/${ip_id}`)
            .then((totResponse) => {
                setTotData(totResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchadvData();
    }, []);
    function fetchadvData() {
        axios.get(`${baseUrl}view-ip-adv/${ip_id}`)
            .then((advResponse) => {
                setAdvData(advResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchinsurData();
    }, []);
    function fetchinsurData() {
        axios.get(`${baseUrl}view-pre-insur/${ip_id}`)
            .then((insResponse) => {
                const filteredData = insResponse.data.filter(item => item.status == 3);
                setInsurData(filteredData);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchdrugData();
    }, []);
    function fetchdrugData() {
        axios.get(`${baseUrl}view-ip-drug/${ip_id}`)
            .then((drugResponse) => {
                setDrugData(drugResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        if (drugData.length > 0) {
            fetchPhData();
        }
    }, [drugData]);
    function fetchPhData() {
        const ipIds = drugData.map(row => row.product.split(',').map(item => item.trim()));
        ipIds.forEach(ipId => {
            try {
                ipId.forEach(id => {
                    axios.get(baseUrl + 'update-indent-use-bill/' + id + '/')
                        .then(function (response) {
                            const data = Object.assign({}, response.data);
                            setViewPharmData(prevData => [...prevData, data]);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                });
            } catch (error) {
                console.log(error);
            }
        });
    }
    useEffect(() => {
        fetchlabData();
    }, []);
    function fetchlabData() {
        axios.get(`${baseUrl}view-ip-lab/${ip_id}`)
            .then((labResponse) => {
                setLabData(labResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchinvData();
    }, []);
    function fetchinvData() {
        axios.get(`${baseUrl}view-ip-inv/${ip_id}`)
            .then((invResponse) => {
                setInvData(invResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchminviewData();
    }, []);
    function fetchminviewData() {
        axios.get(`${baseUrl}view-ip-min/${ip_id}`)
            .then((minviewResponse) => {
                setMinviewData(minviewResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchIprefData();
    }, []);
    async function fetchIprefData() {
        try {
            const iprefResponse = await axios.get(`${baseUrl}view-ip-refund/${ip_id}`);
            const status = (iprefResponse.data[0].refund_status);
            if (status == 2) {
                setIprefundData(iprefResponse.data);
            }
        } catch (error) {
            console.log(error);
        }
    }
    let drugTotalSum = 0;
    let drugPaidSum = 0;
    for (let i = 0; i < drugData.length; i++) {
        drugTotalSum += parseFloat(drugData[i].total);
        if (drugData[i].mode != 'advance') {
            drugPaidSum += parseFloat(drugData[i].paid) || 0;
        }
    }
    let insurTotalSum = 0;
    for (let i = 0; i < insurData.length; i++) {
        insurTotalSum += parseFloat(insurData[i].app_amount);
    }
    let labTotalSum = 0;
    let labPaidSum = 0;
    for (let i = 0; i < labData.length; i++) {
        labTotalSum += parseFloat(labData[i].lab_tot);
        if (labData[i].lab_pmode != 'advance') {
            labPaidSum += parseFloat(labData[i].lab_paid) || 0;
        }
    }
    let invTotalSum = 0;
    let invPaidSum = 0;
    for (let i = 0; i < invData.length; i++) {
        invTotalSum += parseFloat(invData[i].inv_tot);
        if (invData[i].inv_pmode != 'advance') {
            invPaidSum += parseFloat(invData[i].inv_paid) || 0;
        }
    }
    let advTotalSum = 0;
    let advPaidSum = 0;
    for (let i = 0; i < advData.length; i++) {
        advTotalSum += parseFloat(advData[i].advance);
        advPaidSum += parseFloat(advData[i].paid) || 0;
    }
    let minviewTotalSum = 0;
    for (let i = 0; i < minviewData.length; i++) {
        minviewTotalSum += parseFloat(minviewData[i].min_tot);
    }
    let refTotalSum = 0;
    for (let i = 0; i < iprefundData.length; i++) {
        refTotalSum += parseFloat(iprefundData[i].refund_amount);
    }
    minviewTotalSum = parseFloat(minviewTotalSum) || 0;
    invTotalSum = parseFloat(invTotalSum) || 0;
    labTotalSum = parseFloat(labTotalSum) || 0;
    drugTotalSum = parseFloat(drugTotalSum) || 0;
    const InvoicedTotal = minviewTotalSum + invTotalSum + labTotalSum + drugTotalSum;
    advPaidSum = parseFloat(advPaidSum) || 0;
    drugPaidSum = parseFloat(drugPaidSum) || 0;
    invPaidSum = parseFloat(invPaidSum) || 0;
    labPaidSum = parseFloat(labPaidSum) || 0;
    insurTotalSum = parseFloat(insurTotalSum) || 0;
    refTotalSum = parseFloat(refTotalSum) || 0;
    const PaidTotal = advPaidSum + drugPaidSum + invPaidSum + labPaidSum + insurTotalSum - refTotalSum;
    // Calculate the total discount
    const totdisc = totData.reduce((acc, row) => acc + parseFloat(row.tot_disc || 0), 0);
    // Calculate the BalanceTotal
    const BalanceTotal = PaidTotal - InvoicedTotal + totdisc;
    const handlePrint = () => {
    const printElement = document.getElementById("invoice-print");

    if (!printElement) {
        console.error("Print element #invoice-print not found");
        return;
    }

    const printWindow = window.open("", "_blank", "width=1000,height=700");

    if (!printWindow) {
        alert("Please allow pop-ups to print.");
        return;
    }

    // Collect stylesheets and existing styles
    const styles = Array.from(
        document.querySelectorAll('link[rel="stylesheet"], style')
    )
        .map((style) => style.outerHTML)
        .join("\n");

    printWindow.document.open();
    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Print Invoice</title>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />

            ${styles}

            <style>
                @page {
                    size: A4 portrait;
                    margin: 8mm;
                }

                * {
                    box-sizing: border-box;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                }

                html,
                body {
                    width: 100%;
                    margin: 0 !important;
                    padding: 0 !important;
                    background: #fff !important;
                    color: #000 !important;
                    font-size: 10px;
                }

                body {
                    overflow: visible !important;
                }

                #invoice-print {
                    display: block !important;
                    width: 100% !important;
                    max-width: none !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    overflow: visible !important;
                }

                /* Remove responsive scrolling in print */
                .table-responsive,
                .table-responsive-sm,
                .table-responsive-md,
                .table-responsive-lg,
                .table-responsive-xl,
                .table-responsive-xxl {
                    display: block !important;
                    width: 100% !important;
                    max-width: none !important;
                    height: auto !important;
                    overflow: visible !important;
                }

                /* Show the entire table */
                table {
                    width: 100% !important;
                    max-width: none !important;
                    border-collapse: collapse !important;
                    table-layout: auto;
                    font-size: 9px;
                }

                th,
                td {
                    padding: 3px !important;
                    white-space: normal !important;
                    overflow-wrap: anywhere !important;
                    word-break: normal;
                    vertical-align: top !important;
                }

                thead {
                    display: table-header-group;
                }

                tfoot {
                    display: table-footer-group;
                }

                tr {
                    break-inside: avoid;
                    page-break-inside: avoid;
                }

                img {
                    max-width: 100% !important;
                    height: auto;
                }

                /* Prevent clipping by common layout containers */
                .container,
                .container-fluid,
                .row,
                [class*="col-"] {
                    max-width: none !important;
                    overflow: visible !important;
                }

                .d-print-none,
                .no-print {
                    display: none !important;
                }

                @media print {
                    html,
                    body {
                        width: 100% !important;
                        height: auto !important;
                    }
                }
            </style>
        </head>
        <body>
            ${printElement.outerHTML}
        </body>
        </html>
    `);

    printWindow.document.close();

    // Wait for stylesheets and images before printing
    const waitForResources = async () => {
        await Promise.all(
            Array.from(printWindow.document.images).map((img) => {
                if (img.complete) return Promise.resolve();

                return new Promise((resolve) => {
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            })
        );

        if (printWindow.document.fonts?.ready) {
            await printWindow.document.fonts.ready;
        }

        printWindow.focus();

        // Close the print window after printing or cancelling
        printWindow.onafterprint = () => {
            printWindow.close();
        };

        printWindow.print();

        // Fallback for browsers that do not fire afterprint reliably
        printWindow.addEventListener("beforeunload", () => {
            printWindow.close();
        });
    };

    waitForResources();
};

    return (<section className="container mt-4">
        <div id="invoice-print">

            <div
                style={{
                    width: "100%", margin: 0, padding: 0, overflow: "hidden", lineHeight: 0
                }}
            >
                {hospData.map((hospital) => (<img
                    key={hospital.id}
                    src={hospital.logo}
                    alt="Hospital Header"
                    style={{
                        width: "100%",
                        height: "110px",
                        display: "block",
                        margin: 0,
                        padding: 0,
                        border: "none",
                        objectFit: "fill"
                    }}
                />))}
            </div>
            <h4 style={{
                color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between'
            }}>
                    <span
                        style={{alignSelf: 'flex-start'}}>FINAL SETTLEMENT BILL/ RECEIPT- IPB-000{ipData.map(row => row.id)}</span>
                <span style={{alignSelf: 'flex-end'}}>Date : {currentDate}</span>
            </h4>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>

                        <th>IP ID</th>
                        <th>Patient Name</th>
                        <th>Patient ID</th>

                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                        <th>Admit On/Discharged On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (<tr>

                        <td>{patientData.ip_id}</td>
                        <td>{patientData.pat.patient}</td>
                        <td>{patientData.pat.pat_id}</td>

                        <td>{patientData.pat.gender}</td>
                        <td>{patientData.pat.age}</td>
                        <td>{patientData.pat.mobile}</td>
                        <td>{formatDateTime(patientData.admit_date)}</td>
                        <td>
                            {formatDateTime(patientData.admit_date)}
                            {patientData?.discharge_time ? ` / ${formatDateTime(patientData.discharge_time)}` : ''}
                        </td>

                    </tr>))}
                    </tbody>
                </table>
            </div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{color: 'red'}}></i>
                Billing Summary
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>IP Bill Date</th>
                        <th>IP Bill Test</th>
                        <th>IP Bill Invoiced</th>
                        <th>IP Bill Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    {minviewData.map((min, index) => {
                        const testArray = min.min_test.split(",");
                        const amountArray = min.min_amount.split(",");
                        const unitsArray = min.min_units?.split(",") || [];
                        const rows = testArray.map((test, subIndex) => {
                            const isFirstRow = subIndex === 0;
                            const rowspan = testArray.length;
                            const amount = amountArray[subIndex]?.trim() || "0";
                            const units = unitsArray[subIndex]?.trim() || "0";
                            const total = parseFloat(amount) * parseFloat(units);
                            return (<tr
                                    key={`${index}-${subIndex}`}
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {min.add_date}
                                        </td>)}

                                    <td>
                                        {test.trim()}
                                    </td>

                                    <td>
                                        {amount} * {units} = {total}
                                    </td>

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {min.min_tot}
                                        </td>)}
                                </tr>);
                        });
                        return rows;
                    })}
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan="3" style={{textAlign: 'left', fontWeight: 'bold'}}>IP Bill</td>
                        <td style={{textAlign: 'right', fontWeight: 'bold'}}>Rs. {minviewTotalSum.toFixed(2)}</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
            <>
                {labData && labData.length > 0 && (<>

                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Lab Date</th>
                                <th>Lab Test</th>
                                <th>Lab Invoiced</th>
                                <th>Lab Total</th>
                                <th>Lab Paid</th>
                                <th>Lab Balance</th>
                            </tr>
                            </thead>
                            <tbody>
                            {labData.map((lab, index) => {
                                const testArray = lab.lab_test.split(",");
                                const amountArray = lab.lab_amount.split(",");
                                const rows = testArray.map((test, subIndex) => {
                                    const isFirstRow = subIndex === 0;
                                    const rowspan = testArray.length;
                                    return (<tr
                                            key={`${index}-${subIndex}`}
                                            style={{
                                                border: "1px solid", borderColor: "#2194d9"
                                            }}
                                        >
                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {lab.add_date}
                                                </td>)}

                                            <td>
                                                {test.trim()}
                                            </td>

                                            <td>
                                                {amountArray[subIndex]?.trim() || "0"}
                                            </td>

                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {lab.lab_tot}
                                                </td>)}

                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {lab.lab_paid}
                                                </td>)}

                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {lab.lab_balance}
                                                </td>)}
                                        </tr>);
                                });
                                return rows;
                            })}
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan="5" style={{textAlign: 'left', fontWeight: 'bold'}}>Lab</td>
                                <td style={{
                                    textAlign: 'right', fontWeight: 'bold'
                                }}>Rs. {labTotalSum.toFixed(2)}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </>)}
            </>
            <>
                {invData && invData.length > 0 && (<>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Inv Date</th>
                                <th>Inv Test</th>
                                <th>Inv Invoiced</th>
                                <th>Inv Total</th>
                                <th>Inv Paid</th>
                                <th>Inv Balance</th>
                            </tr>
                            </thead>
                            <tbody>
                            {invData.map((inv, index) => {
                                const testArray = inv.inv_test.split(",");
                                const amountArray = inv.inv_amount.split(",");
                                const rows = testArray.map((test, subIndex) => {
                                    const isFirstRow = subIndex === 0;
                                    const rowspan = testArray.length;
                                    return (<tr
                                            key={`${index}-${subIndex}`}
                                            style={{
                                                border: "1px solid", borderColor: "#2194d9"
                                            }}
                                        >
                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {inv.add_date}
                                                </td>)}

                                            <td>
                                                {test.trim()}
                                            </td>

                                            <td>
                                                {amountArray[subIndex]?.trim() || "0"}
                                            </td>

                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {inv.inv_tot}
                                                </td>)}

                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {inv.inv_paid}
                                                </td>)}

                                            {isFirstRow && (<td rowSpan={rowspan}>
                                                    {inv.inv_balance}
                                                </td>)}
                                        </tr>);
                                });
                                return rows;
                            })}
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan="5" style={{textAlign: 'left', fontWeight: 'bold'}}>Radiology</td>
                                <td style={{
                                    textAlign: 'right', fontWeight: 'bold'
                                }}>Rs. {invTotalSum.toFixed(2)}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </>)}
            </>
            <>
                {drugData && drugData.length > 0 && (<>

                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Date</th>
                                <th>Drug</th>
                                <th>Invoiced</th>
                                <th>Total</th>
                                <th>Paid</th>
                                <th>Balance</th>
                            </tr>
                            </thead>
                            <tbody>

                            {drugData.map((drug, index) => {
                                const productArray = drug.product.split(',');
                                const qtyArray = drug.qty.split(','); // Split the qty string into an array
                                const rows = productArray.map((test, subIndex) => {
                                    const pharmData = viewPharmData.find((data) => data.id == test);
                                    const isFirstRow = subIndex === 0;
                                    const rowspan = isFirstRow ? productArray.length : undefined;
                                    return (<tr key={`${index}-${subIndex}`}
                                                style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        {isFirstRow && <td rowSpan={rowspan}>{drug.add_date}</td>}
                                        <td>{pharmData?.product.product}</td>
                                        <td>{pharmData?.product.uamount} * {qtyArray[subIndex]}</td>
                                        {/* Map qty to the correct product */}
                                        {isFirstRow && <td rowSpan={rowspan}>{drug.total}</td>}
                                        {isFirstRow && <td rowSpan={rowspan}>{drug.paid}</td>}
                                        {isFirstRow && <td rowSpan={rowspan}>{drug.balance}</td>}
                                    </tr>);
                                });
                                return rows;
                            })}

                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan="5" style={{textAlign: 'left', fontWeight: 'bold'}}>Drug</td>
                                <td style={{
                                    textAlign: 'right', fontWeight: 'bold'
                                }}>Rs. {Math.round(drugTotalSum)}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </>)}
            </>

            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{color: 'red'}}></i>
                Payment/Invoice List
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Date</th>
                        <th>Test</th>
                        <th>Invoice</th>
                        <th>Invoice Amount</th>
                        <th>Paid</th>
                        <th>Balance</th>
                        <th>Mode</th>
                    </tr>
                    </thead>
                    <tbody>
                    {advData.map((adv, index) => (<tr>
                        <td>{adv.add_date}</td>
                        <td>{adv.adv_type}</td>
                        <td><Link to={`/ip-invoice/${adv.invoice}`} target="_blank">{adv.invoice}</Link></td>
                        <td>{adv.advance}</td>
                        <td>{adv.paid}</td>
                        <td>{adv.balance}</td>
                        <td>{adv.mode}</td>
                    </tr>))}
                    {drugData.map((drug, index) => {
                        const productArray = drug.product.split(',');
                        const qtyArray = drug.qty.split(',');
                        const rows = productArray.map((test, subIndex) => {
                            const pharmData = viewPharmData.find((data) => data.id == test);
                            const isFirstRow = subIndex === 0;
                            const rowspan = isFirstRow ? productArray.length : undefined;
                            return (<tr key={`${index}-${subIndex}`}
                                        style={{border: "1px solid", borderColor: "#2194d9"}}>
                                {isFirstRow && <td rowSpan={rowspan}>{drug.add_date}</td>}
                                <td>{pharmData?.product.product}&nbsp;&nbsp;&nbsp;&nbsp;- {pharmData?.product.uamount} * {qtyArray[subIndex]}&nbsp;&nbsp;&nbsp;</td>

                                {isFirstRow && <td rowSpan={rowspan}><Link
                                                to={`/pharm-invoice-other/${drug.sale_id}`}
                                                target="_blank"
                                            >
                                                {drug.sale_id}
                                            </Link>
                                </td>}
                                {isFirstRow && <td rowSpan={rowspan}>{drug.total}</td>}
                                {isFirstRow && <td rowSpan={rowspan}>{drug.paid}</td>}
                                {isFirstRow && <td rowSpan={rowspan}>{drug.balance}</td>}
                                {isFirstRow && <td rowSpan={rowspan}>{drug.mode}</td>}
                            </tr>);
                        });
                        return rows;
                    })}
                    {labData.map((lab, index) => {
                        if (!(Number(lab.lab_paid) > 0)) return null;
                        const testArray = (lab.lab_test || "").split(",");
                        const invoiceArray = (lab.lab_invoice || "").split(",");
                        const totalArray = String(lab.lab_tot ?? "").split(",");
                        const paidArray = String(lab.lab_paid ?? "").split(",");
                        const balanceArray = String(lab.lab_balance ?? "").split(",");
                        const modeArray = (lab.lab_pmode || "").split(",");
                        const rows = testArray.map((item, subIndex) => {
                            const isFirstRow = subIndex === 0;
                            const rowspan = testArray.length;
                            return (<tr
                                    key={`lab-${index}-${subIndex}`}
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {lab.add_date}
                                        </td>)}

                                    <td>{item.trim()}</td>


                                        {isFirstRow && (<td rowSpan={rowspan}><Link
                                                to={`/lab-invoice-ip/${invoiceArray[subIndex].trim()}`}
                                                target="_blank"
                                            >
                                                {invoiceArray[subIndex].trim()}
                                            </Link>
                                    </td>)}

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {totalArray.map((total, i) => (<div key={i}>{total.trim()}</div>))}
                                        </td>)}

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {paidArray.map((paid, i) => (<div key={i}>{paid.trim()}</div>))}
                                        </td>)}

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {balanceArray.map((balance, i) => (<div key={i}>{balance.trim()}</div>))}
                                        </td>)}

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {modeArray.map((mode, i) => (<div key={i}>{mode.trim()}</div>))}
                                        </td>)}
                                </tr>);
                        });
                        return rows;
                    })}
                    {invData.map((inv, index) => {
                        if (!(Number(inv.inv_paid) > 0)) return null;
                        const testArray = (inv.inv_test || "").split(",");
                        const invoiceArray = (inv.inv_invoice || "").split(",");
                        const totalArray = String(inv.inv_tot ?? "").split(",");
                        const paidArray = String(inv.inv_paid ?? "").split(",");
                        const balanceArray = String(inv.inv_balance ?? "").split(",");
                        const modeArray = (inv.inv_pmode || "").split(",");
                        const rows = testArray.map((item, subIndex) => {
                            const isFirstRow = subIndex === 0;
                            const rowspan = testArray.length;
                            return (<tr
                                    key={`inv-${index}-${subIndex}`}
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {inv.add_date}
                                        </td>)}

                                    <td>{item.trim()}</td>

                                    <td>
                                        {(invoiceArray[subIndex] || "").trim() && (<Link
                                                to={`/inv-invoice-ip/${invoiceArray[subIndex].trim()}`}
                                                target="_blank"
                                            >
                                                {invoiceArray[subIndex].trim()}
                                            </Link>)}
                                    </td>

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {totalArray.map((total, i) => (<div key={i}>{total.trim()}</div>))}
                                        </td>)}

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {paidArray.map((paid, i) => (<div key={i}>{paid.trim()}</div>))}
                                        </td>)}

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {balanceArray.map((balance, i) => (<div key={i}>{balance.trim()}</div>))}
                                        </td>)}

                                    {isFirstRow && (<td rowSpan={rowspan}>
                                            {modeArray.map((mode, i) => (<div key={i}>{mode.trim()}</div>))}
                                        </td>)}
                                </tr>);
                        });
                        return rows;
                    })}
                    {/*{minviewData.map((min, index) => {*/}
                    {/*    const testArray = (min.min_test || "").split(",");*/}
                    {/*    const amountArray = (min.min_amount || "").split(",");*/}
                    {/*    const unitsArray = (min.min_units || "").split(",");*/}
                    {/*    const rows = testArray.map((item, subIndex) => {*/}
                    {/*        const isFirstRow = subIndex === 0;*/}
                    {/*        const rowspan = testArray.length;*/}
                    {/*        const amount = (amountArray[subIndex] || "").trim();*/}
                    {/*        const unit = (unitsArray[subIndex] || "").trim();*/}
                    {/*        const amountValue = parseFloat(amount) || 0;*/}
                    {/*        const unitValue = parseFloat(unit) || 0;*/}
                    {/*        return (<tr*/}
                    {/*                key={`min-${index}-${subIndex}`}*/}
                    {/*                style={{*/}
                    {/*                    border: "1px solid", borderColor: "#2194d9"*/}
                    {/*                }}*/}
                    {/*            >*/}
                    {/*                {isFirstRow && (<td rowSpan={rowspan}>*/}
                    {/*                        {min.add_date}*/}
                    {/*                    </td>)}*/}

                    {/*                <td>{item.trim()}</td>*/}


                    {/*                <td>*/}
                    {/*                    {amount} * {unit} = {amountValue * unitValue}*/}
                    {/*                </td>*/}
                    {/*                {isFirstRow && (<td rowSpan={rowspan}>*/}
                    {/*                        {min.min_tot}*/}
                    {/*                    </td>)}*/}

                    {/*                <td></td>*/}
                    {/*                <td></td>*/}
                    {/*                <td></td>*/}
                    {/*            </tr>);*/}
                    {/*    });*/}
                    {/*    return rows;*/}
                    {/*})}*/}
                    {totData.map((row, index) => (row.tot_disc > 0 ? (<tr key={index}>
                        <td>{row.add_date}</td>
                        <td>Discount Amount</td>
                        <td></td>
                        <td>{row.tot_disc}</td>
                        <td></td>
                        <td></td>
                        <td>{row.disc_reason}</td>
                    </tr>) : null))}
                    </tbody>
                </table>
            </div>
            <>
                {insurData && insurData.length > 0 && (<>
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                        <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true"
                           style={{color: 'red'}}></i>
                        Insurance Details
                    </h3>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Insurance Type</th>
                                <th>Claim Date</th>
                                <th>CCN No</th>
                                <th>Claimed By</th>
                                <th>Est Amount</th>
                                <th>Pending Amount</th>
                                <th>Approved Amount</th>
                                <th>Reason</th>
                            </tr>
                            </thead>
                            <tbody>
                            {insurData.map((ins, index) => {
                                const pdamt = parseFloat(ins.est_amount - ins.app_amount);
                                const instype = ipData.map(row => row.insur_cmpy.company);
                                return (<tr key={index}>
                                    <td>{instype}</td>
                                    <td>{ins.ccn}</td>
                                    <td>{ins.app_date}</td>
                                    <td>{ins.addedby}</td>
                                    <td>{ins.est_amount}</td>
                                    <td>{pdamt}</td>
                                    <td>{ins.app_amount}</td>
                                    <td>{ins.reason}</td>
                                </tr>);
                            })}
                            </tbody>
                        </table>
                    </div>
                </>)}
            </>
            <>
                {iprefundData && iprefundData.length > 0 && (<>
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                        <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true"
                           style={{color: 'red'}}></i>
                        Refund Details
                    </h3>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Refund Date</th>
                                <th>Refund Type</th>
                                <th>Refund Amount</th>
                                <th>Receipt</th>
                                <th>Received By</th>
                                <th>Reason</th>
                            </tr>
                            </thead>
                            <tbody>
                            {iprefundData.map((ref, index) => (<tr>
                                <td>{ref.add_date}</td>
                                <td>{ref.refund_type}</td>
                                <td>{ref.refund_amount}</td>
                                <td><Link to={`/refund-invoice-ip/${ref.receipt}`}
                                          target="_blank">{ref.receipt}</Link></td>
                                <td>{ref.receivedby}</td>
                                <td>{ref.reason}</td>
                            </tr>))}
                            </tbody>
                        </table>
                    </div>
                </>)}
            </>
            <h4 style={{
                color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between'
            }}>
                <span style={{alignSelf: 'flex-start'}}>Total Invoiced</span>
                <span style={{alignSelf: 'flex-end'}}>Rs.{Math.round(InvoicedTotal)}</span>
            </h4>
            <h4 style={{
                color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between'
            }}>
                <span style={{alignSelf: 'flex-start'}}>Net Payment Amount</span>
                <span style={{alignSelf: 'flex-end'}}>Rs.{Math.round(PaidTotal)}</span>
            </h4>

            <h4 style={{
                color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between'
            }}>
                <span style={{alignSelf: 'flex-start'}}>Balance Amount</span>
                <span style={{alignSelf: 'flex-end'}}>Rs.{Math.round(BalanceTotal)}</span>

            </h4>

            <table border='1' width="100%">
                <thead>
                <tr>
                    <th className="text-end"><strong>For {hospData.map(row => row.hospital)}</strong></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td width="100%">
                        <table width="100%">
                            <tr>
                                <th width="100%" className="text-end">Authorized Staff:</th>
                            </tr>
                            <tr>
                                <th width="100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                            </tr>
                            <tr>
                                <th width="100%" className="text-end">(Name & Signature)</th>
                            </tr>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} className="mt-2">
            <button style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                    onClick={handlePrint}
            >
                Print
            </button>
        </div>
    </section>)
}
export default IpBillSummary;